$shm_hitalama_map_widget_float_settings_text_md $shm_hitalama_map_widget_float_settings
	controlled_settings_content /
		<= Code
